module.exports = __webpack_public_path__ + "img/40.bab9691.png";